// extracted by mini-css-extract-plugin
export var dropdownIcon = "_n1-6";
export var imgContainer = "_n1-3";
export var menuIcon = "_n1-5";
export var pillWrapper = "_n1-2";
export var pillsContainer = "_n1-1";
export var subscriptionCard = "_n1-0";
export var subscriptionLogo = "_n1-4";